export default __webpack_public_path__ + "static/speednet-844657d730dd87cdeadf9b38c005f5de.png";